import { render, staticRenderFns } from "./SecuritySwitch.vue?vue&type=template&id=5fd38a88&scoped=true"
import script from "./SecuritySwitch.vue.js?vue&type=script&lang=js&external"
export * from "./SecuritySwitch.vue.js?vue&type=script&lang=js&external"
import style0 from "./SecuritySwitch.vue?vue&type=style&index=0&id=5fd38a88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd38a88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VImg,VSnackbar,VTab,VTabs})
